/**
 * Step 3: Initialize tunnel width and height to system minimums
 */
import { IAHUParams, IBotData } from '../../../../models';
import { dispatchMutation } from '../../../../utils/dispatch.utils';
import { ahuApi } from '../../../../services';

export async function step3InitializeTunnelDimensions(
  tunnels: any[],
  tunnelIds: number[],
  ahuParams: IAHUParams,
  botData: IBotData,
  getOptions: () => { signal?: AbortSignal },
): Promise<any[]> {
  const dimensions = ahuParams.dimensions;
  const defaultWidth = dimensions?.tunnel_cabinet_width_min || 0;
  const defaultHeight = dimensions?.tunnel_cabinet_height_min || 0;

  // Determine base_id: if model with id 100223 exists, use it, else use first model id
  let baseId: number | null = null;
  if (ahuParams.base && ahuParams.base.length > 0) {
    baseId = (
      ahuParams.base.find((base) => base.id === 100223) || ahuParams.base[0]
    ).id;
  }

  const updatedTunnels: any[] = [];

  for (let i = 0; i < tunnels.length; i++) {
    const tunnel = tunnels[i];
    const needsWidthHeightUpdate =
      tunnel.width !== defaultWidth || tunnel.height !== defaultHeight;
    const needsBaseIdUpdate = tunnel.base_id !== baseId;

    if (needsWidthHeightUpdate || needsBaseIdUpdate) {
      const updateData: any = {
        airflow_direction_id: botData.tunnels[i].airflow_direction_id || 1,
      };
      if (needsWidthHeightUpdate) {
        updateData.width = defaultWidth;
        updateData.height = defaultHeight;
      }
      if (needsBaseIdUpdate) {
        updateData.base_id = baseId;
      }

      const updatedTunnel = await dispatchMutation(
        ahuApi.endpoints.updateAhuTunnel,
        {
          id: tunnelIds[i],
          body: updateData,
        },
        getOptions(),
      );
      updatedTunnels.push(updatedTunnel);
    } else {
      updatedTunnels.push(tunnel);
    }
  }

  return updatedTunnels;
}
